import { isString } from 'util';
export default {
    computed: {
        currentView () {
            return (this.$route.name === 'home' || this.$route.name === 'index') ? 'home' : this.$route.name;
        },
        sortedTableData: function () {
            var sortType;

            for (let index = 0; index < this.tableColumns.length; index++) {
                const column = this.tableColumns[index];

                if (column.dataField === this.sortField) {
                    sortType = column.type;
                }
            }

            return _.orderBy(this.tableData, (obj) => {
                switch (sortType) {
                    case 'string':
                        return obj[this.sortField];
                    case 'percent':
                        if (isString(obj[this.sortField])) {
                            return (Number(obj[this.sortField].split('<')[1].split('%')[0]) - 0.5) / 100;
                        } else {
                            return obj[this.sortField];
                        }
                    case 'number':
                        if (isString(obj[this.sortField])) {
                            return Number(obj[this.sortField].split('<')[1]) - 0.5;
                        } else {
                            return obj[this.sortField];
                        }
                    default:
                        return obj[this.sortField];
                }
            }, [this.sortDir, 'asc']);
        },
    },
    methods: {
        getSelectedYearData (year) {
            return $.getJSON('data/' + year + '.json');
        }
    },

};